import type { Locale } from '@/lib/locale';
import sv from './sv.json';

// Server-side: load both languages sync so SSR can render any locale immediately.
// Client-side: only ship sv in the main bundle (~70 KB) and lazy-load en in its own
// chunk on first English t() call. ~99% of visitors are Swedish so en is never
// downloaded for them.
//
// For English visitors the SSR HTML already contains the correct strings (server
// had en loaded), so users don't see Swedish-flash before en hydrates. Any extra
// English t() calls after hydration use the cached chunk.

let en: Record<string, string> | null = null;

if (typeof window === 'undefined') {
  // Server-side: bypass webpack's dynamic-import splitting via require().
  // Node has no concept of chunks so this is essentially a sync inline.
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    en = require('./en.json');
  } catch {
    en = null;
  }
}

let enClientLoading: Promise<void> | null = null;
function ensureEnClient(): Record<string, string> | null {
  if (en) return en;
  if (typeof window !== 'undefined' && !enClientLoading) {
    enClientLoading = import('./en.json').then(m => {
      en = (m as { default: Record<string, string> }).default;
    });
  }
  return null;
}

const sv_table = sv as Record<string, string>;

export function t(locale: Locale, key: string, params?: Record<string, string | number>): string {
  let table: Record<string, string>;
  if (locale === 'en') {
    table = en || ensureEnClient() || sv_table;
  } else {
    table = sv_table;
  }
  const str = table[key] ?? sv_table[key] ?? key;
  if (!params) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => String(params[k] ?? `{${k}}`));
}
